(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pinr-bulk-quote"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pinr-bulk-quote')){
customElements.define('pinr-bulk-quote',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;
this.initialized=true;
this.dialog=this.querySelector('dialog');
this.variant=this.querySelector('[data-quote-variant]');
this.quantity=this.querySelector('[data-quote-quantity]');
this.productField=this.querySelector('[data-quote-product]');
this.querySelector('[data-quote-open]').addEventListener('click',()=>this.open());
this.querySelector('[data-quote-close]').addEventListener('click',()=>this.dialog.close());
this.variant?.addEventListener('change',()=>{this.variantDirty=true;this.updateSku();});
this.quantity?.addEventListener('input',()=>{this.quantityDirty=true;});
this.productField?.addEventListener('change',()=>{
if(this.productField.selectedIndex===1&&this.variant){
this.variant.value='Custom size / configuration';this.variantDirty=true;this.updateSku();
}
});
this.querySelector('form').addEventListener('submit',()=>this.updateSku());
this.dialog.addEventListener('click',event=>{
if(event.target!==this.dialog)return;
const b=this.dialog.getBoundingClientRect();
if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();
});
if(this.querySelector('[data-quote-feedback]'))this.dialog.showModal();
}
updateSku(){
const sku=this.querySelector('[data-quote-sku]');
if(sku)sku.value=this.variant?.selectedOptions[0]?.dataset.sku||'';
}
syncSelection(){
const form=this.closest('.product-details')?.querySelector('product-form-component form');
const id=form?.querySelector('[name="id"]')?.value;
if(this.variant&&!this.variantDirty){
const option=Array.from(this.variant.options).find(item=>item.dataset.variantId===id);
if(option)this.variant.value=option.value;
}
if(this.quantity&&!this.quantityDirty)this.quantity.value=form?.querySelector('[name="quantity"]')?.value||'1';
this.updateSku();
}
open(){this.syncSelection();if(!this.dialog.open)this.dialog.showModal();}
});
document.addEventListener('click',event=>{
const link=event.target.closest('a[href="/pages/contact"]');
const quote=document.querySelector('pinr-bulk-quote');
if(!link||!quote||!link.closest('.product-details'))return;
event.preventDefault();quote.open();
});
}
  } catch(e) { console.error(e); }
})();

})();
